const isNil = value => value === null || value === undefined;

export default isNil;



// WEBPACK FOOTER //
// ./Private/Scripts/helpers/isNil.js